import {memo, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {handleRequest, apiError, numberFormat, renderDate} from "~/utils";
import {employeeEvaluationApi} from "~/api";
import FontAwesomeIcon from "~/components/FontAwesome";
import {Image} from "~/components";
import DashboardWidgetHeader from "./DashboardWidgetHeader";

/**
 * Widget dashboard nhân sự: danh sách nhân viên chưa đạt doanh số (theo chu kỳ 3 ngày / 7 ngày).
 * Tái dùng API danh sách đánh giá (lọc status=fail), tự lấy dữ liệu bằng local state.
 */
function EvaluationFailedWidget({
	type = '3day',
	title,
	icon = 'fa-light fa-gauge-circle-bolt',
	gradient,
	limit = 6,
	fetcher,
}) {

	const [items, setItems]     = useState([]);
	const [total, setTotal]     = useState(0);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let mounted = true;
		setLoading(true);
		const request = fetcher
			? fetcher({type, limit})
			: employeeEvaluationApi.gets({type, status: 'fail', page: 1, limit});
		handleRequest(request).then(([err, res]) => {
			if (!mounted) return;
			if (!apiError('', err, res) && res?.data) {
				setItems(res.data);
				setTotal(res.pagination?.total ?? res.data.length);
			}
			setLoading(false);
		});
		return () => { mounted = false; };
	}, [type, limit, fetcher]);

	const viewAllLink = (
		<Link to="/employee-evaluation" style={{
			color: '#fff', fontSize: 11, opacity: 0.85,
			display: 'flex', alignItems: 'center', gap: 3, textDecoration: 'none',
		}}>
			Xem tất cả <FontAwesomeIcon icon="fa-light fa-arrow-right" />
		</Link>
	);

	return (
		<div style={{borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 12px rgba(239,68,68,0.12)', background: '#fff'}}>
			<DashboardWidgetHeader
				icon={icon}
				title={title}
				gradient={gradient}
				badge={total > 0 ? `${total} chưa đạt` : null}
				extra={viewAllLink}
			/>

			<div style={{padding: '12px 18px'}}>
				{loading && (
					<div style={{textAlign: 'center', padding: '16px 0', color: '#94a3b8', fontSize: 13}}>
						<FontAwesomeIcon icon="fa-light fa-loader" spin style={{marginRight: 6}} />
						Đang tải...
					</div>
				)}

				{!loading && items.length === 0 && (
					<div style={{textAlign: 'center', padding: '20px 0', color: '#94a3b8'}}>
						<FontAwesomeIcon icon="fa-light fa-circle-check" style={{fontSize: 26, display: 'block', marginBottom: 6, color: '#10b981'}} />
						<span style={{fontSize: 12}}>Không có nhân viên chưa đạt</span>
					</div>
				)}

				{!loading && items.map((item, index) => {
					const u       = item.user || {};
					const name    = u.firstname ? `${u.firstname} ${u.lastname}` : `#${item.userId}`;
					const isLast  = index === items.length - 1;

					return (
						<div key={item.id} style={{
							display: 'flex', gap: 10, alignItems: 'center',
							paddingBottom: isLast ? 4 : 12, marginBottom: isLast ? 0 : 12,
							borderBottom: isLast ? 'none' : '1px dashed #e2e8f0',
						}}>
							<div className="avatar" style={{width: 40, height: 40, flexShrink: 0}}><Image src={u.avatar} /></div>

							<div style={{flex: 1, minWidth: 0}}>
								<b style={{fontSize: 13, color: '#1e293b', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{name}</b>
								<span style={{fontSize: 11, color: '#64748b'}}>
									<FontAwesomeIcon icon="fa-light fa-calendar-day" style={{marginRight: 4}} />
									ĐG: {renderDate(item.evaluateTime)}
								</span>
							</div>

							<div style={{textAlign: 'right', flexShrink: 0}}>
								<b style={{fontSize: 13, color: '#ef4444'}}>{numberFormat(item.revenue)}</b>
								<p style={{fontSize: 11, color: '#94a3b8', margin: 0}}>Mốc: {numberFormat(item.target)}</p>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default memo(EvaluationFailedWidget);
